import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { Text } from "@ui"

import { IllustratedState } from "../../../components/IllustratedState"
import { ErrorState } from "./-Error"
import { listQuery } from "./-list.query"
import { Parrot } from "./-Parrot"

const RouteComponent = () => {
  const { data } = useSuspenseQuery(listQuery)

  if (data.conversations.length === 0) {
    return (
      <IllustratedState
        title="The conversation parrot has nothing to repeat"
        description="No conversations in this period yet. As soon as one comes in, it lands here."
      >
        <Parrot />
      </IllustratedState>
    )
  }

  return (
    <Text whiteSpace="breakSpace">
      {JSON.stringify(data, undefined, "   ")}
    </Text>
  )
}

export const Route = createFileRoute("/_chrome/conversations/")({
  loader: ({ context }) => {
    void context.queryClient.query(listQuery)
  },
  component: RouteComponent,
  errorComponent: ErrorState,
  pendingComponent: () => <div>Loading</div>,
})
